import React from 'react';
import { motion } from 'framer-motion';
import { VideoIcon } from 'lucide-react';
const VIDEOS = [{
  title: 'Built from the barrel up',
  detail: 'The oak grain, steel bands, and custom finish that make each piece one of a kind.',
  posterUrl: 'https://cdn.magicpatterns.com/uploads/qun8CEDaN7CvVB16sBoXNS/Screenshot_2026-07-18_at_1.43.24_AM.png',
  videoUrl: 'https://cdn.magicpatterns.com/uploads/1S4J4NyYP71EhPkSiC7qYC/IMG_5956.MOV'
}, {
  title: 'The finishing mark',
  detail: 'A small detail that makes every Castle Barrel unmistakably yours.',
  posterUrl: 'https://cdn.magicpatterns.com/uploads/dTdHhkEwQtqXGs7qvvHtL2/IMG_5900.jpg',
  videoUrl: 'https://cdn.magicpatterns.com/uploads/c9SEHSpXxd8a5jVyB5P99W/IMG_5957.MOV'
}];
export function VideoFeature() {
  return <section id="video" className="bg-parchment py-16 sm:py-24" data-id="element-149" data-mp="3isiy2y0ee2i9">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-150" data-mp="3nrvr60hv45ta">
        <div data-id="element-151" data-mp="3nrdoom4lwvcx">
          <span className="font-stamp text-xs uppercase tracking-[0.25em] text-wine" data-id="element-152" data-mp="3nr3zh0rdys8a">
            Behind the Barrel
          </span>
          <h2 className="mt-3 font-display text-3xl text-oak-dark sm:text-4xl" data-id="element-153" data-mp="ip13zjhic1xj">
            Watch the craft at work.
          </h2>
          <p className="mt-3 font-body text-base leading-relaxed text-bark/80 lg:whitespace-nowrap lg:text-lg" data-id="element-154" data-mp="wnipdajxx2ca">
            Take a closer look at the materials, mechanisms, and hands-on details behind every barrel.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-155" data-mp="4v9q5ywqtvw0">
          {VIDEOS.map((video, index) => <motion.article key={video.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="overflow-hidden rounded-sm border-2 border-oak-dark bg-bark shadow-lg" data-id="element-156" data-mp="dpo7s84qxiia" data-mpi={index}>
              <div className="relative aspect-video" data-id="element-157" data-mp="3dbd0kcf8pyo1">
                <video controls poster={video.posterUrl} className="h-full w-full object-cover" aria-label={video.title} data-id="element-158" data-mp="1gbs1rtvi5rb5">
                  <source src={video.videoUrl} type="video/mp4" data-id="element-159" data-mp="1q2v3mxw9aabh" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="border-t-2 border-oak-light/40 px-5 py-4 text-cream sm:px-6 sm:py-5" data-id="element-160" data-mp="xeh4getfl7yc">
                <div className="flex items-start justify-between gap-4" data-id="element-161" data-mp="12bz57hxaogv9">
                  <div data-id="element-162" data-mp="17c4zl5uy8hh1">
                    <h3 className="font-display text-xl text-cream" data-id="element-163" data-mp="17blp2a7movd1">{video.title}</h3>
                    <p className="mt-2 font-body text-sm leading-relaxed text-parchment/75" data-id="element-164" data-mp="1cbhlnodzxkik">
                      {video.detail}
                    </p>
                  </div>
                  <VideoIcon className="mt-1 h-6 w-6 shrink-0 text-oak-light" aria-hidden="true" data-id="element-165" data-mp="2nq3iia1r4l4i" />
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}